import { AuthConfig } from '@auth0/auth0-angular';

export const environment = {
  production: false,
  apiBaseUrl: 'https://api.boots.agents.dev.jplus.io',
  isAuditFlowEnabled: false,
  authConfig: {
    domain: 'jellyfish-dev.eu.auth0.com',
    clientId: 'gCvsafykTRExmKQLWqRDwcGyrNbesq0q',
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    audience: '',
    scope: 'openid profile email',
    authorizationParams: {
      redirect_uri: `${window.location.origin}/auth-callback`,
    },
    errorPath: '/access-denied',
  } as AuthConfig,
};
